export default __webpack_public_path__ + "static/media/add-event.96741624.svg";